import { toPackageName } from '@atlassian/jira-project-settings-apps-common/src/consts.tsx';
import type { PackageName } from '@atlassian/jira-project-settings-apps-common/src/types.tsx';

export const PACKAGE_NAME: PackageName = toPackageName('jiraProjectDirectoriesComponents');
